import {
  ChatChoiceWidget,
  ChatDeeplink,
  ChatHistoryCitationV2,
  CitationWidget,
  CustomerSupportChatWidget,
  DeeplinkWidget,
} from 'generated/types'

export type MessageFooterWidgets =
  | CitationWidget
  | DeeplinkWidget
  | CustomerSupportChatWidget
  | ChatChoiceWidget

export const extractWidgets = (
  chatWidgets: Array<MessageFooterWidgets>,
): {
  citations: ChatHistoryCitationV2[]
  deeplinks: ChatDeeplink[]
  customerSupportChatWidgets: CustomerSupportChatWidget[]
  chatChoices: ChatChoiceWidget | undefined
} => {
  const citations: ChatHistoryCitationV2[] = []
  const deeplinks: ChatDeeplink[] = []
  const customerSupportChatWidgets: CustomerSupportChatWidget[] = []
  let chatChoices: ChatChoiceWidget | undefined = undefined

  for (const widget of chatWidgets) {
    if (widget.__typename === 'CitationWidget') {
      citations.push(
        ...widget.citations.filter(
          (citation) => citation.__typename === 'SupportCitation',
        ),
      )
    }

    if (widget.__typename === 'DeeplinkWidget') {
      deeplinks.push(...widget.deeplinks)
    }

    if (widget.__typename === 'CustomerSupportChatWidget') {
      customerSupportChatWidgets.push(widget)
    }

    if (widget.__typename === 'ChatChoiceWidget') {
      chatChoices = widget
    }
  }

  return {
    citations,
    deeplinks,
    customerSupportChatWidgets,
    chatChoices,
  }
}
